export default "__VITE_ASSET__CgnbOOJj__"